import { render, staticRenderFns } from "./LenderOtpView.vue?vue&type=template&id=184bdeb5&scoped=true&"
import script from "./LenderOtpView.vue?vue&type=script&lang=js&"
export * from "./LenderOtpView.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=184bdeb5&scoped=true&lang=css&"
import style1 from "./LenderOtpView.vue?vue&type=style&index=1&id=184bdeb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184bdeb5",
  null
  
)

export default component.exports